//@ts-nocheck
import { memo, FunctionComponent } from 'react';
import COLORS from '../../theme/Colors';
import { Container, StyledOption } from './styles/SelectStyles';
import { FieldTitle, Row, StyledTextInput } from '../../theme/Styles';
import CircularProgress from '@mui/material/CircularProgress';
import CheckRender from '../CheckRender/CheckRender';
import { optionItems } from './SelectConstants';
import { Autocomplete } from '@mui/material';

const Select: FunctionComponent<propTypes> = (props) => {
    let objectValue = props.value === undefined ? null : props.data?.find((item) => item.value == props.value)
    return (
        <Container>
            <Row>
                <FieldTitle>{props.title} </FieldTitle>
                <div style={{ width: '5px' }} />
                <CheckRender allowed={props.required}>
                    <FieldTitle style={{ color: COLORS.red }}>*</FieldTitle>
                </CheckRender>
            </Row>

            {
                props.search ?

                    <Autocomplete
                        disablePortal
                        fullWidth
                        disableClearable
                        select
                        unselectable
                        noOptionsText="No hay opciones"
                        id={props.id}
                        name={props.id}
                        placeholder={props.placeholder}
                        value={objectValue}
                        inputValue={props.inputValue}
                        disabled={props.disabled}
                        options={props.data}
                        getOptionLabel={(option) => option.label}
                        onInputChange={(e, newInputValue) => props.onInputValueChange && props.onInputValueChange({
                            target: {
                                id: props.id,
                                value: newInputValue
                            }
                        })}
                        onChange={(e, newValue) => props.onChange && props.onChange({
                            target: {
                                id: props.id,
                                value: newValue.value
                            }
                        })}
                        ListboxProps={{ style: { margin: 0 } }}
                        /* onBlur={(e,newValue) => onBlur && onBlur({
                                target:{
                                    id:id,
                                    value:newValue.value
                                }
                            })}*/
                        
                        renderInput={(params) =>
                            <StyledTextInput {...params}
                                InputProps={{
                                    ...params.InputProps,
                                    style: { padding: 2, }
                                }}
                                helperText={props.helperText}
                                FormHelperTextProps={{ sx: { fontSize: '0.90rem' } }}
                                error={props.error}
                            />}
                    />
                    :
                    <StyledTextInput
                        fullWidth
                        select
                        disabled={props.disabled}
                        id={props.id}
                        placeholder={props.placeholder}
                        value={props.value}
                        onBlur={props.onBlur}
                        onChange={props.onChange}
                        helperText={props.helperText}
                     FormHelperTextProps={{ sx: { fontSize: '0.90rem' } }}
                        error={props.error}
                        InputProps={{
                            endAdornment: props.endAdornment,
                            startAdornment: props.startAdornment
                        }}
                        SelectProps={{
                            unselectable: 'on',
                            native: true //for use option tag instead of MenuItem
                        }}
                    >
                        <StyledOption unselectable />
                        {props.data.map((option) => ( //use option or StyledOption instead of MenuItem because this tag has an bug 
                            <StyledOption key={option.value} value={option.value}>
                                {option.label}
                            </StyledOption>
                        ))}
                    </StyledTextInput>
            }

        </Container>
    );
};

export interface propTypes {
    id: string;
    title?: string;
    placeholder?: string;
    value?: string | number;
    inputValue?: string;
    objectValue?: object;
    data: optionItems | any;
    onInputValueChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
    error?: boolean;
    required?: boolean;
    disabled?: boolean;
    endAdornment?: any;
    startAdornment?: React.ReactNode;
    helperText?: string | boolean;
    search?: boolean
}

Select.defaultProps = {
    helperText: " ",
    search: false
}

export default memo(Select);